var FormService = function ($resource) {
    return {
        getFormGroupClass: function (form, fieldName) {
            var field = form[fieldName];

            return typeof field !== 'undefined' && field.$invalid && field.$dirty ? 'has-error' : '';
        },
        isDirty: function (form, fieldName) {
            var field = form[fieldName];

            return typeof field !== 'undefined' && field.$dirty ? true : false;
        },
        getFieldError: function (form, fieldName) {
            var field = form[fieldName];

            return typeof field !== 'undefined' && field.$error ? field.$error : {};
        }
    };
};

FormService.$inject = ['$resource'];
export default FormService;